import React from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import withBoundary from 'component/ErrorBoundary/withBoundary';
function ListButton(props) {
  const { children, variant, onClick, big, gray, small } = props;

  return (
    <Button
      variant={variant}
      sx={
        (small && styles.Button) ||
        (gray && styles.grayButton) ||
        (big && styles.bigButton)
      }
      onClick={onClick}>
      {children}
    </Button>
  );
}
ListButton.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.string,
  onClick: PropTypes.func,
  big: PropTypes.bool,
  gray: PropTypes.bool,
  small: PropTypes.bool
};
export default React.memo(withBoundary(ListButton));
